import mountReactApp from 'mount-react-app';
import { routes, reducers } from 'flights-seo-dweb';

function renderApp() {
  const initialState = window.__initial_state__;
  initialState.seo.departure.dateObj = new Date(initialState.seo.departure.dateObj);
  if (initialState.seo.arrival) {
    initialState.seo.arrival.dateObj = new Date(initialState.seo.arrival.dateObj);
  }

  initialState.seo.searchWidget.departure.dateObj = new Date(
    initialState.seo.searchWidget.departure.dateObj
  );
  if (initialState.seo.searchWidget.arrival) {
    initialState.seo.searchWidget.arrival.dateObj = new Date(
      initialState.seo.searchWidget.arrival.dateObj
    );
  }
  mountReactApp({ routes, reducers, initialState });
}

renderApp();

if (module.hot) {
  module.hot.accept('flights-seo-dweb', () => renderApp());
}
